import React from 'react'

export type CreateIconProps = {
  color?: string
  className?: string
  size?: number
}

/**
 * "Create" plus affordance from the Design Library (node 2387:8615). A + glyph
 * spanning the full bounds, stroke-width 1.5. Defaults to `currentColor` so it
 * inherits the surrounding text color (e.g. a Button's on-accent color).
 */
export const CreateIcon = ({
  color = 'currentColor',
  className,
  size = 11,
}: CreateIconProps) => (
  <svg
    aria-label='Create'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 11 11'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <line stroke={color} strokeWidth='1.5' x1='5.75' x2='5.75' y1='0' y2='11' />
    <line
      stroke={color}
      strokeWidth='1.5'
      x1='11'
      x2='0'
      y1='5.51667'
      y2='5.51667'
    />
  </svg>
)
